import ky from 'ky';
export class CortexClient {
    http;
    constructor(config) {
        this.http = ky.create({
            prefixUrl: config.baseUrl.replace(/\/$/, ''),
            timeout: config.timeout ?? 30_000,
            hooks: {
                beforeRequest: [
                    (req) => {
                        if (config.jwt)
                            req.headers.set('Authorization', `Bearer ${config.jwt}`);
                    },
                ],
                afterResponse: [
                    (_req, _opts, res) => {
                        if (res.status === 401)
                            config.onUnauthorized?.();
                    },
                ],
            },
        });
    }
}
//# sourceMappingURL=client.js.map